export default __webpack_public_path__ + "static/media/modavest-brand.6b476dce.svg";